import {
	type Grouping,
	CustomFieldTypes,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';

export const isRoadmapGroupedByCustomField = (grouping: Grouping) => /^customfield_/.test(grouping);

export const getCustomFieldIdFromCustomFieldGrouping = (grouping: Grouping) =>
	grouping.substring('customfield_'.length);

export const isMultiSelectCustomField = (fieldType: string) =>
	fieldType === CustomFieldTypes.MultiSelect;

export const isLabelCustomField = (fieldType: string) => fieldType === CustomFieldTypes.Labels;
